// extracted by mini-css-extract-plugin
export var primary = "Button-module--primary--43524";
export var secondary = "Button-module--secondary--02b0c";
export var wrapper = "Button-module--wrapper--cd794";